const en = {
  // Navigation
  nav_home: "Home",
  nav_explore: "Explore",
  nav_workspace: "Workspace",
  ws_videos: "videos",
  ws_untitled: "Untitled video",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Video failed",
  ws_failed_refunded: "Your credit was returned",
  ws_failed_dismiss: "Dismiss",
  ws_failed_retry: "Try again",
  ws_failed_retrying: "Starting…",
  ws_failed_banner_one: "A video failed to generate",
  ws_failed_banner_many: "{n} videos failed",
  ws_failed_banner_body: "Nothing was charged — the credit went back to your account. Try again, or pick a different topic.",
  ws_empty_title: "Nothing here yet.",
  ws_empty_body: "Every video you make will appear here, newest first.",
  ws_generate: "Generate",
  ws_composer_placeholder: "Describe a lesson\u2026",
  ws_placeholder_hw: "Name the assignment… (optional)",
  ws_placeholder_lecture: "Name the lecture… (optional)",
  ws_placeholder_self_study: "What do you want to study?",
  nav_search: "Search videos...",
  nav_search_yours: "Search your videos...",
  nav_notifications: "Notifications",
  nav_mark_all_read: "Mark all read",
  nav_no_notifications: "No notifications yet",
  nav_no_notifications_sub: "We'll notify you when your videos are ready",
  nav_upgrade: "Upgrade",
  nav_billing: "Billing",
  nav_settings: "Settings",
  nav_contact: "Contact Us",
  nav_api: "API",
  nav_sign_out: "Sign out",
  nav_just_now: "Just now",
  nav_minutes_ago: "{n}m ago",
  nav_hours_ago: "{n}h ago",
  nav_days_ago: "{n}d ago",
  nav_used_this_month: "{used} of {cap} used this month",
  // UNUSED as of 2026-09-10. The signed-in free bucket became per calendar month and the
  // call site moved to nav_used_this_month above, which already carried the right sentence
  // in all 15 locales. Left defined rather than deleted: removing a key means editing every
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} of {limit} used this week",
  nav_free_daily: "4 free videos per week",

  // Settings
  settings_title: "Settings",
  settings_profile: "Profile",
  settings_change_avatar: "Change avatar",
  settings_cancel: "Cancel",
  settings_choose_wizard: "Choose your wizard",
  settings_display_name: "Display name",
  settings_your_name: "Your name",
  settings_save: "Save",
  settings_saving: "Saving...",
  settings_saved: "Saved",
  settings_save_failed: "Failed to save",
  settings_email: "Email",
  settings_notifications: "Notifications",
  settings_email_notif: "Email notifications",
  settings_email_notif_desc: "Receive updates and announcements via email",
  settings_language: "Language",
  settings_language_desc: "Choose the language for the app and video narration",
  settings_data_title: "Your data",
  settings_data_desc: "Download a copy of the personal data associated with your account — including your profile, videos, courses, sessions, and support messages. Internal system logs and derived processing data are not included.",
  settings_data_download: "Download my data",
  settings_data_exporting: "Preparing…",
  settings_danger: "Danger Zone",
  settings_delete_account: "Delete Account",
  settings_delete_desc: "Permanently delete your account and all associated data. This action cannot be undone.",
  settings_delete_confirm: "This will permanently delete your account and all your data. Type {keyword} to confirm.",
  settings_delete_placeholder: 'Type "DELETE" to confirm',
  settings_permanently_delete: "Permanently Delete",
  settings_deleting: "Deleting...",


  explore_watch_now: "Watch Now",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "No preview",
  explore_no_videos: "No videos available yet. Check back soon!",
  explore_featured_courses: "Featured Courses",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Back to Explore",
  course_not_found: "This course isn't available.",

  // Home Page
  home_hero: "Learn anything, ",
  home_hero_accent: "visually",
  home_placeholder: "What do you want to learn or solve?",
  home_extracting: "Extracting questions...",
  home_videos_generated: "{n, plural, one {# video} other {# videos}} will be generated",
  home_credits: "{n, plural, one {# credit} other {# credits}}",
  home_remaining: "remaining this month",
  home_enter_prompt: "Please enter what you want to learn or solve",
  home_popular: "Popular Lessons",
  home_from_community: "From the community",
  home_community_sub: "See what students are creating",
  home_tips_label: "From the Magi wizard",
  home_tips_title: "Tips & Tricks",
  home_tip1_title: "Get specific",
  home_tip1_desc: "Don't type a whole subject. Pick one idea, one concept, one question.",
  home_tip1_example: "How DNA replication works in eukaryotic cells",
  home_tip2_title: "Say who it's for",
  home_tip2_desc: "A middle school explanation looks completely different from a college lecture.",
  home_tip2_example: "Explain derivatives for someone who just learned algebra",
  home_tip3_title: "Tell Magi what you want",
  home_tip3_desc: "Examples, step-by-step, real-world applications — just say it and Magi will follow.",
  home_tip3_example: "The water cycle with real-world examples and a summary",
  home_tip_try: "Try something like",
  home_proven_social: "Follow us on Instagram",
  home_ig_desc_1: "Over ",
  home_ig_followers: "55,000 followers",
  home_ig_desc_2: " watch our math and science videos on Instagram every day. These reels are made with the same engine you use here.",
  home_view_profile: "View profile",
  home_subscribe_now: "Subscribe now",


  home_sub_monthly: "Monthly",
  home_sub_yearly: "Yearly",
  // The percentage is interpolated from the live plan prices, never written into the string —
  // a hardcoded "Save 17%" / "2 months free" (both of which lived here) states a discount that
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Save {pct}%",
  home_sub_per_month: "/ month",
  home_sub_billed_monthly: "billed ${amount} every month",
  home_sub_processing: "Processing...",
  home_sub_no_commitment: "No commitment. Cancel anytime.",
  home_sub_secured: "Secured by Stripe",
  home_sub_headline: "Unlock more with {plan}",
  home_sub_due_now: "Due now",
  home_sub_trial_label: "{days}-day full access",
  // Deliberately mirrors home_sub_trial_terms clause for clause: charged today, what it buys,
  // the renewal date, the recurring amount and frequency, and how to cancel. Auto-renewal law
  // (California ARL, FTC negative-option) expects those facts before consent, and a customer
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "You'll be charged ${amount} today for {n} videos this month. On {date} it renews at ${amount}/month unless you cancel first — cancel any time from Billing.",
  // "Renews" understated it: the trial does not renew, it CONVERTS to a different and much
  // higher price. The wording now says the price changes, names the new plan, amount and
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "You'll be charged ${trial} today for {days} days of full access, capped at {n} videos. The trial does not continue at ${trial} — on {date} it automatically becomes {planName} at ${plan} per month ({full} videos), and ${plan} is charged every month after that until you cancel. Cancel any time from Billing.",
  home_sub_card: "Credit or Debit Card",
  home_sub_billed_once_yearly: "billed ${amount} once a year",
  home_sub_billed_trial: "billed ${amount} for {days} days, then renews at ${renews} every month",
  home_sub_switch_plan: "Looking for {plan} instead?",
  home_sub_replaces_plan: "Replaces your {plan} plan. Your billing date stays the same — moving up charges the difference now, moving down starts at your next renewal.",
  home_sub_change_now: "You're on {plan} now — charged {amount} for the difference.",
  home_sub_change_later: "You'll move to {plan} on {date}. Nothing charged today.",
  // Interpolated, not per-count keys. The `_50`/`_120` pair below went stale the moment
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} videos per month",
  // Pricing Page
  pricing_title: "Upgrade your plan",
  pricing_monthly: "Monthly",
  pricing_yearly: "Yearly",
  pricing_save: "Save 17%",
  pricing_best_value: "Best Value",
  pricing_your_plan: "Your current plan",
  pricing_get_started: "Get started",
  pricing_processing: "Processing...",
  pricing_per_month: "/month",
  pricing_billed_yearly: "Billed ${amount}/year",
  pricing_videos_month: "{n, plural, one {# video} other {# videos}}/month",
  pricing_manage_cancel: "Manage or cancel",
  pricing_manage_unavailable: "We couldn't find a subscription to manage. Please contact us and we'll sort it out.",
  pricing_opening: "Opening...",
  billing_autorenew_monthly: "Renews automatically at ${amount}/month until you cancel.",
  billing_autorenew_yearly: "Renews automatically at ${amount}/year until you cancel.",
  billing_autorenews_on: "Auto-renews {date} · cancel anytime",
  pricing_secured: "Secured by Stripe",
  pricing_login_required: "Please log in to subscribe",
  pricing_auth_error: "User authentication error. Please try logging out and back in.",
  pricing_feature_pdf: "PDF & image extraction",
  pricing_feature_quality: "Higher quality model",
  pricing_feature_speed: "Faster generation time",
  pricing_feature_study: "Study sessions",
  pricing_free_hint: "Currently on the Free plan",

  // Billing Page
  billing_title: "Billing",
  billing_current_plan: "Current Plan",
  billing_payment_failed_title: "Your plan is paused",
  billing_payment_failed_body: "We couldn't collect {amount}, so your plan is paused. Update your card to start it again — we'll also keep retrying.",
  billing_payment_failed_cta: "Fix payment",
  billing_change_plan: "Change plan",
  billing_invoices: "Invoices",
  billing_loading: "Loading invoices...",
  billing_no_invoices: "No invoices yet",
  billing_date: "Date",
  billing_amount: "Amount",
  billing_status: "Status",
  billing_invoice: "Invoice",
  billing_view: "View",

  // Contact Page
  contact_title: "Contact Us",
  contact_placeholder: "How can we help?",
  contact_sent_desc: "We'll get back to you as soon as possible.",
  contact_signin: "Please sign in to contact support.",

  // Generation Queue
  queue_title: "Queue",
  queue_active: "{n} active",
  queue_generating: "{n} generating",
  queue_ready: "Ready to watch",
  queue_in_queue: "Waiting in queue...",
  queue_almost_ready: "Almost ready...",
  queue_seconds_left: "{n}s left",
  queue_minutes_left: "{m}m {s}s left",
  queue_watch_now: "Watch now",
  queue_waiting: "Waiting in queue...",
  queue_empty: "No videos in queue",
  queue_empty_sub: "Generate a video to see it here",
  queue_clear: "Clear all",
  queue_total: "{n} total",
  queue_first_time: "Your video is being generated",
  queue_first_time_sub: "Usually ~2 min. You'll hear a chime when it's ready.",

  // Session Expired
  session_expired: "Session Expired",
  session_expired_desc: "Your session has expired for security reasons. Please sign in again to continue.",


  // Cookie Banner
  cookie_text: "We use cookies to analyze site traffic and improve your experience. Only essential cookies are set by default.",
  cookie_learn_more: "Learn more",
  cookie_accept: "Accept all",
  cookie_reject: "Reject non-essential",

  // Create Project Modal
  create_new_project: "New Project",
  create_extracting: "Extracting...",
  create_select_problems: "Select Problems",
  create_select_topics: "Select Topics",
  create_new_video: "New Video",
  create_new_hw: "New Homework Project",
  create_new_lecture: "New Lecture Project",
  create_new_self_study: "New Project",
  create_video: "Video",
  create_homework: "Homework",
  create_lecture: "Lecture",
  create_self_study: "Project",
  create_video_sub: "Generate a video",
  create_hw_sub: "Upload homework",
  create_lecture_sub: "Upload slides",
  create_self_study_sub: "Choose your topics",
  create_video_prompt: "What should the video explain?",
  create_project_title: "Project title",
  create_video_hint: "This will be used as both the title and the prompt for your video.",
  create_drop_hw: "Drop your homework here",
  create_drop_lecture: "Drop your lecture slides here",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Drop to start a project",
  create_reading_hw: "Reading your homework",
  create_reading_lecture: "Reading your lecture",
  create_finding_problems: "Finding and extracting problems...",
  create_finding_topics: "Extracting topics...",
  create_add_video: "Add another video",
  create_add_more_files: "Add more files",
  create_starting: "Starting generation...",
  create_generate_video: "Generate Video \u00B7 1 credit",
  create_generate_n: "Generate {n, plural, one {# Video} other {# Videos}} \u00B7 {n, plural, one {# credit} other {# credits}}",
  create_create_project: "Create Project \u00B7 {n, plural, one {# credit} other {# credits}}",
  create_no_problems: "Couldn't find any problems. Try a clearer photo or different page.",
  create_no_topics: "Couldn't find any topics. Try a clearer photo or different file.",
  create_error: "Something went wrong. Please try again.",
  create_extract_daily_limit: "That's all the documents for today. More tomorrow.",
  create_video_topic_placeholder: 'Video {n} topic, e.g. "Eigenvalues and Eigenvectors"',


  video_share: "Share",
  // Says GENERATE, not "ask". This box spends a credit and makes a whole new video; the free
  // question box is the pause-to-ask panel on the player. "Ask a follow-up..." read as chat
  // and made the two indistinguishable.
  video_followup_placeholder: "Generate follow up video...",
  video_chip_simpler: "Explain simpler",
  video_chip_harder: "Harder example",
  video_chip_real_world: "Real-world use",
  // Pause-to-ask panel (over the right of the video). "Ask" language throughout — this
  // answers about the current video and is free, unlike the follow-up composer above, which
  // spends a credit generating a new one.
  video_ask_title: "Ask about this video",
  video_ask_cta: "Chat about this",
  video_ask_placeholder: "Ask a question...",
  video_ask_thinking: "Thinking...",
  video_ask_close: "Close",
  video_ask_chip_explain: "Explain that part",
  video_ask_chip_example: "Give an example",
  video_ask_chip_why: "Why does that work?",
  video_ask_limit_reached: "You have reached today's question limit. It resets tomorrow.",
  video_up_next: "Up Next",
  video_no_suggested: "No suggested videos yet",
  video_untitled: "Untitled Video",
  video_created_recently: "Created recently",
  video_just_now: "Just now",
  video_minutes_ago: "{n, plural, one {# minute} other {# minutes}} ago",
  video_hours_ago: "{n, plural, one {# hour} other {# hours}} ago",
  video_days_ago: "{n, plural, one {# day} other {# days}} ago",
  video_weeks_ago: "{n, plural, one {# week} other {# weeks}} ago",
  video_months_ago: "{n, plural, one {# month} other {# months}} ago",
  video_years_ago: "{n, plural, one {# year} other {# years}} ago",
  video_unknown_date: "Unknown date",
  video_download_error: "Something went wrong. Please try again.",

  // Search Results
  search_no_results: "No results found",
  search_no_results_for: 'No results found for "{query}"',
  search_all_videos: "Search all videos",
  search_enter_term: "Enter a search term to find videos",
  search_retry: "Retry Search",

  auth_continue_google: "Continue with Google",
  // Purchase-time consent. Stripe's dispute guidance is explicit that requiring agreement to
  // your terms "increases the likelihood that card issuers respect your policies in the event
  // of a dispute" — and the card networks expect the cancellation/refund policy to be accepted
  // before checkout, not merely linked somewhere on the site.
  // The EU/UK withdrawal waiver. Two things must be true for it to hold: the customer ASKED
  // for immediate access, and they ACKNOWLEDGED what that costs them. Both are in this one
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Start my access straight away. I understand this means I give up my {days}-day right to withdraw and get a refund.",
  home_sub_waiver_required: "Please confirm this to continue.",
  home_sub_agree_prefix: "By continuing, you agree to our ",
  // {age} is resolved per visitor from their country's GDPR Art. 8 digital age of consent
  // (utils/constants.js), so this is 13 in most of the world and 16 in Germany. The Terms'
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "You must be {age} or older to use Magi.",
  auth_agree_prefix: "By signing in, you agree to our ",
  auth_terms: "Terms of Service",
  auth_and: " and ",
  auth_privacy: "Privacy Policy",
  auth_email_optin: "Send me tips and updates",

  // Auth modal (Google + email/password)
  auth_signin_title: "Sign in to Magi",
  auth_signin_desc: "Pick up where you left off.",
  auth_signup_title: "Create your account",
  auth_signup_desc: "Free to start, no card needed.",
  auth_or: "or",
  auth_continue_email: "Continue with email",
  auth_signing_in: "Signing in…",
  auth_working: "Just a sec…",
  auth_email_placeholder: "Email address",
  auth_password_placeholder: "Password",
  auth_signin_submit: "Sign in",
  auth_signup_submit: "Create account",
  auth_no_account: "New here?",
  auth_signup_link: "Create an account",
  auth_have_account: "Already have an account?",
  auth_signin_link: "Sign in",
  auth_forgot_password: "Forgot your password?",
  auth_reset_title: "Reset your password",
  auth_reset_desc: "We'll email you a link to set a new one.",
  auth_reset_submit: "Send reset link",
  auth_reset_sent: "Check your email for the reset link.",
  auth_back_to_signin: "Back to sign in",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Confirm your email to continue",
  verify_wall_desc: "We sent a confirmation link to {email}. Click it, then come back here.",
  verify_wall_check: "I've confirmed it",
  verify_wall_checking: "Checking...",
  verify_wall_still_unverified: "Not confirmed yet. Click the link in the email, then try again.",
  verify_wall_resend: "Send the link again",
  verify_wall_resent: "Sent. Check your inbox and your spam folder.",
  verify_wall_wrong_account: "Wrong account? Sign out",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Confirming your email",
  verify_action_working_desc: "One moment.",
  verify_action_done_title: "You're all set",
  verify_action_done_desc: "Your email is confirmed. Welcome to Magi.",
  verify_action_done_cta: "Start learning",
  verify_action_failed_title: "That link didn't work",
  verify_action_failed_desc: "It may have already been used, or it expired. Head back and send yourself a fresh one.",
  verify_action_failed_cta: "Back to Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Sign in to watch",
  auth_watch_desc: "Create a free account to play this video.",
  auth_watch_ready_title: "Your video is ready",
  auth_watch_ready_desc: "Sign in to watch it — it'll be saved to your account.",
  // Watching is free; these are the actions that are not. Each names what the account unlocks
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Sign in to download",
  auth_download_desc: "Create a free account to save this video.",
  auth_ask_title: "Sign in to ask",
  auth_ask_desc: "Create a free account to ask about this video.",
  auth_browse_title: "Sign in to browse",
  auth_browse_desc: "Create a free account to explore every lesson.",
  auth_workspace_title: "Sign in to see your work",
  auth_workspace_desc: "Your lessons and projects live in your account.",
  auth_generate_title: "Sign in to keep creating",
  auth_generate_desc: "Free accounts get a video every day.",
  video_restricted: "This video isn't available yet.",


  // Share sheet
  share_title: "Share this video",
  share_desc_mobile: "Post it to your story, send it to a friend, or copy the link.",
  share_desc_desktop: "Copy the link, or download the video to post from your phone.",
  share_to_apps: "Share to Instagram & more",
  share_copy_link: "Copy link",
  share_copied: "Link copied",
  share_download: "Download video",
  share_preparing: "Getting it ready…",
  share_watermark_note: "Shared videos include magiacademy.com",

  // Welcome Modal (post-signup)
  welcome_title: "Welcome to Magi",
  welcome_subtitle: "You have 4 free videos to start.",
  welcome_optin_reward: "+1 free video",
  welcome_continue: "Continue",

  age_gate_continue: "Continue",
  age_gate_saving: "Saving...",

  // Landing Page
  landing_hero: "Type a topic.",
  landing_hero2: "Get a video lesson.",
  landing_subtitle: "Magi turns any subject into a beautifully animated, narrated video in minutes. No filming, no editing, no expertise needed.",
  landing_signup_google: "Sign up with Google",
  landing_signing_in: "Signing in...",
  landing_chat_bubble: "How does GPS use relativity?",
  landing_stats_title: "Trusted by learners worldwide",
  landing_stat_videos: "3,000+",
  landing_stat_videos_desc: "Videos generated",
  landing_stat_languages_desc: "Languages",
  landing_stat_speed: "~1 min",
  landing_stat_speed_desc: "Generation time",
  landing_feature_lecture_title: "Drop your lecture notes, get videos",
  landing_feature_lecture_desc: "Upload your slides or notes. Magi pulls out each topic and generates a video explanation for every one.",
  landing_feature_hw_title: "Stuck on homework? Upload it.",
  landing_feature_hw_desc: "Drop a problem set and Magi extracts each problem, then walks you through the solution in a step-by-step video.",
  landing_feature_chat_title: "Ask questions while you watch",
  landing_feature_chat_desc: "Every video comes with an AI tutor you can chat with. Ask follow-up questions, get deeper explanations, or request a new video on a specific part you want to understand better.",
  landing_feature_lang_title: "Learn in your language",
  landing_feature_lang_desc: "Magi generates videos in English, Spanish, Hindi, Chinese, Japanese, and more. Type your topic in any language and get a fully narrated lesson back in that language.",
  landing_cta_title: "Start learning in seconds",
  landing_cta_google: "Continue with Google",

  // Onboarding Bubbles
  onboarding_step1: "This isn't a chatbot \u2014 type a topic and I'll generate a full video lesson for you!",
  onboarding_step2: "Or drop a PDF or photo \u2014 I'll turn every problem into a step-by-step video solution",
  onboarding_step3: "Hit go and your video joins the queue. You can keep browsing while it renders!",
  onboarding_generating: "This is your lesson being drawn \u2014 a couple of minutes. Keep browsing if you like; it'll land right here when it's ready.",
  onboarding_skip: "Skip",
  onboarding_next: "Next",
  onboarding_done: "Got it!",

  // Generating Cards Row
  generating_label: "Generating",

  // Lecture Session (Self Study)
  lecture_loading: "Loading...",
  lecture_fallback_title: "Lecture",
  lecture_building: "Building video...",
  lecture_building_time: "This usually takes 2-4 minutes",
  lecture_failed: "Video generation failed",
  lecture_no_video: "No video yet",
  lecture_followup: "Follow-up",
  lecture_now_playing: "Now playing",
  lecture_tab_videos: "Videos",
  lecture_tab_chat: "Chat",
  lecture_chat_empty: "Ask anything about this topic",
  lecture_chat_chip1: "Explain simply",
  lecture_chat_chip2: "Give an example",
  lecture_chat_chip3: "Why is this useful?",
  lecture_chat_placeholder: "Ask about this topic...",
  lecture_followup_placeholder: "Add a follow-up video...",
  lecture_chat_error: "Sorry, I couldn't process that. Try again.",
  lecture_chat_generic_error: "Something went wrong. Try again.",

  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Homework PDF",
  home_sc_hw_desc: "Upload a problem set, get a worked video for every question",
  home_sc_lecture_title: "Lecture PDF",
  home_sc_lecture_desc: "Turn slides or notes into a series of lessons",
  home_sc_course_title: "Create a course",
  home_sc_course_desc: "Plan a sequence of lessons on one topic",

  // Misc
  generic_error: "Something went wrong. Please try again.",
  loading: "Loading...",
};

export default en;
